var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5",attrs:{"fluid":""}},[_c('div',[_c('h1',[_vm._v("Usuários")])])])}
var staticRenderFns = []

export { render, staticRenderFns }